import { useState } from 'react'
import useInterval from '../../Interval/useInterval'
import { getAuth } from 'firebase/auth'

export default function useCheckVerification() {
	const [userIsVerified, setUserIsVerified] = useState<boolean>(false)

	useInterval(async () => {
		const auth = getAuth()
		await auth.currentUser?.reload()
		setUserIsVerified(!!auth.currentUser?.emailVerified)
	}, 2000)

	return {
		userIsVerified,
	}
}
